<template>

  <!-- bottomShelf -->
  <div id="bottomShelf" class="visible" :class="microNoteIsCompleted && showButtons ? 'score-container' : 'wordbank-container'">

    <transition name="fade">
      <div v-if="microNoteIsCompleted">
        <div v-if="showButtons">
          <MicroNoteScore />
          <StudyIntervalButtons :microNote="microNote" />
        </div>
        <div v-else class="continue">
          <h3>Ready to continue?</h3>
          <div class="btn-group">
            <button v-on:click.prevent="previousMicroNote" type="button" class="btn btn-default"><i class="mdi mdi-chevron-left"></i> &nbsp; Previous</button>
            <button v-on:click.prevent="nextMicroNote" type="button" class="btn btn-default">Next &nbsp; <i class="mdi mdi-chevron-right"></i></button>
          </div>
        </div>
      </div>
      
    </transition>

    <div class="wordbank-wrapper" v-if="!microNoteIsCompleted">
      <div class="wordbank-toggle">
        <span class="lbl">Word bank</span>
        <BoolSwitch :toggle-bool="wordbankVisible" :toggle-function="toggleWordbank" on-text="On" off-text="Off"></BoolSwitch>
      </div>
      <Wordbank v-if="wordbankVisible" :words="wordbankWords" />
    </div>

  </div>

</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import Wordbank from './Wordbank'
import StudyIntervalButtons from './StudyIntervalButtons'
import MicroNoteScore from './MicroNoteScore'
import BoolSwitch from '../shared/controls/BoolSwitch'
import _ from 'underscore'

export default {
    props: ['microNote', 'chapter'],

  components: {
    Wordbank,
    StudyIntervalButtons,
    MicroNoteScore,
    BoolSwitch,
  },

    beforeMount() {
      this.wordbankVisible = (this.chapter && this.chapter.WordbankVisible != null) ? this.chapter.WordbankVisible : true;
  },

  methods: {
    toggleWordbank(value) {
      this.wordbankVisible = value;
      if (this.chapter) {
        const changes = Object.assign({}, this.chapter, { WordbankVisible: this.wordbankVisible });
        this.$store.dispatch('updateChapter', {
          id: this.chapter.id,
          changes,
          callback: (err) => {
          },
        });
      }
    },
    nextMicroNote() {
      this.$store.dispatch('studier/nextMicroNote')
    },

    previousMicroNote() {
      this.$store.dispatch('studier/previousMicroNote')
    },
  },

  data() {
    return {
      wordbankVisible: true,
    }
  },

  computed: {
    ...mapGetters({
      wordbankWords: 'studier/wordbankWords',
      microNoteIsCompleted: 'studier/microNoteIsCompleted',
    }),
    showButtons() {
      return _.values(this.$store.state.studier.keywords).length > 0;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .wordbank-container { height: 120px; }

  .score-container { height: 190px; }

  .continue {text-align:center;}
  .continue .btn {line-height:40px;}

#bottomShelf {
  padding: 10px;
  background-color: #FAFAFA;
  position: fixed;
  bottom: 0; left: 0; right: 0;
  transition:all 0.2s;
  bottom: -120px;

  border-top: 1px solid #e8e8e8;
  z-index: 1031;

  -webkit-transition: all 0.35s ease;
  -o-transition: all 0.35s ease;
  transition: all 0.35s ease;

  .wordbank-wrapper {
    position:relative;
    .wordbank-toggle {
      position:absolute;
      top:0px;
      right:18px;
    }
    .lbl {display:inline-block;padding:4px 10px;}
  }
}

#bottomShelf.visible {
  bottom: 0;
}

</style>



// WEBPACK FOOTER //
// BottomShelf.vue?c584e2fe